import {
	Building2,
	FileText,
	Trees,
	Warehouse,
	Users,
	Tractor,
	Truck,
	Share2,
	Tags,
	Sprout,
	Apple,
	Wheat,
	Boxes,
	ListChecks,
	Sun,
	Target,
	Wrench,
	Droplets,
	Building,
	Package,
} from "lucide-react";

export const SIDEBAR_SECTIONS = [
	{
		key: "general",
		title: "General",
		subtitle: "Empresa y ubicaciones",
		Icon: Building,
		count: 4,
	},
	{
		key: "users",
		title: "Usuarios",
		subtitle: "Equipos y permisos",
		Icon: Users,
		count: 4,
	},
	{
		key: "businessCenter",
		title: "Centros de Costo",
		subtitle: "Categorías y especies",
		Icon: Tags,
		count: 6,
	},
	{
		key: "orderApplication",
		title: "Orden de Aplicación",
		subtitle: "Tipos, estados y maquinaria",
		Icon: Package,
		count: 5,
	},
	{
		key: "purchaseOrder",
		title: "Orden de Compra",
		subtitle: "Categorías de insumos",
		Icon: Package,
		count: 1,
	},
];

export const SECTIONS_CONFIG = {
	general: {
		title: "Configuración General",
		subtitle: "Administra la información básica de tu empresa, campos y bodegas.",
		cards: [
			{
				key: "customers",
				title: "Cliente",
				description: "Información general de la empresa y datos fiscales",
				to: "/configuracion/razon_social",
				Icon: Building2,
				count: 1,
			},
			{
				key: "custom_fields",
				title: "Razones Sociales",
				description: "Gestiona las diferentes razones sociales de tu empresa",
				to: "/configuracion/campos_personalizados",
				Icon: FileText,
				count: 3,
			},
			{
				key: "estates",
				title: "Campos",
				description: "Administra los campos y predios de producción",
				to: "/configuracion/campos",
				Icon: Trees,
				count: 12,
			},
			{
				key: "warehouses",
				title: "Bodegas",
				description: "Configura las bodegas y almacenes disponibles",
				to: "/configuracion/bodegas",
				Icon: Warehouse,
				count: 8,
			},
		],
	},
	users: {
		title: "Configuración de Usuarios",
		subtitle: "Gestiona usuarios, operadores y permisos del sistema.",
		cards: [
			{
				key: "users",
				title: "Usuarios",
				description: "Administra los usuarios del sistema",
				to: "/configuracion/usuarios",
				Icon: Users,
			},
			{
				key: "operators",
				title: "Operadores",
				description: "Gestiona los operadores de campo",
				to: "/configuracion/operadores",
				Icon: Tractor,
			},
			{
				key: "hauliers",
				title: "Transportistas",
				description: "Configura los transportistas",
				to: "/configuracion/transportistas",
				Icon: Truck,
			},
			{
				key: "distribution_lists",
				title: "Listas de Difusión",
				description: "Administra listas de notificaciones",
				to: "/configuracion/listas_difusion",
				Icon: Share2,
			},
		],
	},
	businessCenter: {
		title: "Centros de Costo",
		subtitle: "Configura categorías, especies y estructura de cultivos.",
		cards: [
			{
				key: "business_centers",
				title: "Centros de Costo",
				description: "Define centros de costo",
				to: "/configuracion/centros_costos",
				Icon: Tags,
			},
			{
				key: "species",
				title: "Especies",
				description: "Gestiona especies de cultivos",
				to: "/configuracion/especies",
				Icon: Sprout,
			},
			{
				key: "varieties",
				title: "Variedades",
				description: "Administra variedades por especie",
				to: "/configuracion/variedades",
				Icon: Apple,
			},
			{
				key: "crops",
				title: "Cultivos",
				description: "Configura cuarteles y cultivos",
				to: "/configuracion/cuarteles",
				Icon: Wheat,
			},
			{
				key: "categories",
				title: "Categorías",
				description: "Define categorías de productos",
				to: "/mantenedores/categorias",
				Icon: Boxes,
			},
		],
	},
	orderApplication: {
		title: "Orden de Aplicación",
		subtitle: "Define tipos, estados fenológicos, objetivos y maquinaria.",
		cards: [
			{
				key: "type_oa",
				title: "Tipos OA",
				description: "Tipos de órdenes de aplicación disponibles",
				to: "/configuracion/tipo_orden_aplicacion",
				Icon: ListChecks,
				count: 4,
			},
			{
				key: "phenological_state",
				title: "Estado Fenológico",
				description: "Estados de desarrollo de los cultivos",
				to: "/configuracion/estado_fenologico_oa",
				Icon: Sun,
				count: 12,
			},
			{
				key: "objectives",
				title: "Objetivos OA",
				description: "Objetivos para las órdenes de aplicación",
				to: "/configuracion/objetivos_oa",
				Icon: Target,
				count: 8,
			},
			{
				key: "machineries",
				title: "Maquinarias",
				description: "Equipos y maquinaria para aplicaciones",
				to: "/configuracion/maquinarias",
				Icon: Wrench,
				count: 16,
			},
			{
				key: "irrigations",
				title: "Sectores de Riego",
				description: "Configuración de sectores y zonas de riego",
				to: "/configuracion/riegos",
				Icon: Droplets,
				count: 28,
			},
		],
	},
	purchaseOrder: {
		title: "Orden de Compra",
		subtitle: "Gestiona categorías de insumos y productos.",
		cards: [
			{
				key: "categories_oc",
				title: "Categorías OC",
				description: "Categorías de insumos",
				to: "/configuracion/categorias_oc",
				Icon: Tags,
			},
		],
	},
};

export const EXPORT_CONFIG = {
	url: "/app/tracking/export",
	api: "go",
	type: "excel",
	filePrefix: "Actividad de Usuarios",
};
